<script lang="ts" setup>
  import { RouteLocation } from 'vue-router'
  import { storeToRefs } from 'pinia'
  import { definePageMeta } from '#imports'
  import InteractionHead from '~/components/InteractionHead/InteractionHead.vue'
  import { useGameContentStore } from '~/store/GameContent'
  import GameHierarchyLabel from '~/components/GameHierarchyLabel/GameHierarchyLabel.vue'
  import { GameHierarchyId } from '~/model/GameHierarchy/GameHierarchy'
  import { useGameStateStore } from '~/store/GameState'
  import { GameInteractionId } from '~/model/GameInteraction/GameInteraction'
  import useRouteRecord from '~/composables/RouteRecord/RouteRecord'
  import { MiddlewareKey } from '#build/types/middleware'
  import useGameLogic from '~/composables/GameLogic/GameLogic'

  const gameContentStore = useGameContentStore()
  const gameStateStore = useGameStateStore()

  const { interactionContent } = storeToRefs(gameContentStore)
  const { visitedInteractionList } = storeToRefs(gameStateStore)
  const { interactionParam } = useRouteRecord()
  const { handleStartNotification } = useGameLogic()

  definePageMeta({
    key: (route: RouteLocation) => route.fullPath,
    layout: 'game-content',
    middleware: process.client ? ['game' as MiddlewareKey, 'interaction'] : ['interaction'],
  })

  const onRendered = () => {
    const id = interactionParam.value as GameInteractionId
    visitedInteractionList.value.add(id)
  }

  onMounted(handleStartNotification)
</script>

<template>
  <div class="c-page s-page s-page--fill u-typography-root">
    <div class="c-page__header">
      <InteractionHead :interaction-content="interactionContent" @mounted="onRendered">
        <template #label>
          <GameHierarchyLabel :hierarchy-id="GameHierarchyId.Interaction" />
        </template>
      </InteractionHead>
    </div>
    <div class="c-page__main">
      <ClientOnly>
        <InteractionBody v-if="interactionContent" :content="interactionContent" />
      </ClientOnly>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @use '/assets/scss/util/color/color' as col;

  .c-page__header {
    color: col.$variant-cyan-light;
    background-color: col.$monochrome-lead;
  }
</style>
